module.exports = __webpack_public_path__ + "static/media/image.be4488ea.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/Blog/WhyNFPsNeed/image.jpg
// module id = 75
// module chunks = 0